import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { Card } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import SuiTypography from "components/SuiTypography";
import ImageCardWrapper from "components/UpStyled/ImageCardWrapper";
import ImportSingleStyleModal from "pages/de/portfolio/components/ImportSingleStyleModal";

import { AccountContext } from "context/account";
import api from "services/api";
import toast from "react-hot-toast";

const ProductCard = ({
  index,
  product,
  imageOnly = true,
  handleClick = () => {},
  handleEdit = null,
  handleRemove = null,
  noEdit = false,
  editable,
  slot,
  handleRefresh = () => {},
  ...rest
}) => {
  const [isHover, setIsHover] = useState(false);
  const [importStyleVisible, setImportStyleVisible] = useState(false);
  const account = useContext(AccountContext);

  const handleRemoveProduct = async () => {
    if (!slot) {
      toast.error("Can't find the selected slot!");
    }

    if (!index && !product) {
      toast.error("Can't find the item!");
    }

    if (account.id) {
      let old_portfolio = account?.metadata?.portfolio_content || {};
      if (!old_portfolio[slot]) {
        old_portfolio[slot] = [];
      }

      //if product not null, then edit the product

      let findIndex = index; //using index
      if (!index && product) {
        //using img url & item.id as id
        findIndex = old_portfolio[slot].findIndex(
          (x) => x?.img?.url == product?.img?.url && x?.id == product?.id
        );
      }

      let list = old_portfolio[slot];
      list.splice(findIndex, 1);
      old_portfolio[slot] = list;

      let payload = {
        metadata: {
          ...account?.metadata,
          portfolio_content: old_portfolio,
        },
      };
      try {
        const { data } = await api.account.update(account.id, payload);
        handleRefresh();

        toast.success(`Remove style from portfolio successfully!`);
      } catch (err) {
        console.log(err);
        toast.error(`Remove style from portfolio failed!`);
      }
    } else {
      toast.error("Can't find the user!");
    }
  };

  return (
    <div onMouseEnter={() => setIsHover(true)} onMouseLeave={() => setIsHover(false)}>
      {" "}
      <SuiBox
        onClick={(e) => handleClick(e, slot, product)}
        sx={{
          cursor: "pointer",
          backgroundImage: ({ functions: { rgba, linearGradient }, palette: { gradients } }) =>
            `${linearGradient(
              rgba(gradients.secondary.state, 0.1),
              rgba(gradients.secondary.state, 0.1)
            )}`,
          boxShadow: ({ boxShadows: { lg } }) => (isHover ? lg : "none"),
          overflow: "hidden",
          position: "relative",
          display: "flex",
          minWidth: 0,
          width: "100%",
          ...rest?.sx,
        }}
        className="hover-parent"
      >
        <ImageCardWrapper
          data={product?.img}
          height={360}
          width={"auto"}
          onDragStart={(e) => e.preventDefault()}
          draggable={false}
          resizeLimit={"0"}
          {...rest}
        />
        {editable ? (
          <SuiBox
            position="absolute"
            sx={{ bottom: 20, left: 0, width: "100%", opacity: 0 }}
            className="hover-children"
          >
            <SuiBox display="flex" alignItems="center" justifyContent="center" gap={1}>
              {noEdit ? null : (
                <SuiButton
                  variant="gradient"
                  color="white"
                  size="small"
                  style={{ padding: 0 }}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (handleEdit) {
                      handleEdit(e);
                    } else {
                      setImportStyleVisible(true);
                    }
                  }}
                >
                  Edit
                </SuiButton>
              )}
              <SuiButton
                variant="gradient"
                color="error"
                size="small"
                style={{ padding: 0 }}
                onClick={(e) => {
                  e.stopPropagation();
                  if (handleRemove) {
                    handleRemove(e);
                  } else {
                    handleRemoveProduct(e);
                  }
                }}
              >
                Remove
              </SuiButton>
            </SuiBox>
          </SuiBox>
        ) : null}
      </SuiBox>
      {imageOnly ? null : (
        <SuiTypography
          variant="h6"
          textTransform="none"
          color="secondary"
          sx={{
            mt: 0.5,
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: "1",
            WebkitBoxOrient: "vertical",
          }}
        >
          {product?.title}
        </SuiTypography>
      )}
      {importStyleVisible ? (
        <ImportSingleStyleModal
          handleClose={() => setImportStyleVisible(false)}
          visible={importStyleVisible}
          isEdit={false}
          collection={null}
          handleRefresh={() => {
            handleRefresh();
          }}
          slot={slot}
          type="style"
          product={product}
          index={index}
        />
      ) : null}
    </div>
  );
};
export default ProductCard;
